import { connect } from 'react-redux';
import { changeLocale } from '../actions/index';
// Components
import Locale from '../components/layout/nav/locale/Locale';

const languages = ['en', 'es', 'pt'];

const mapStateToProps = (state) => {
  return {
    locale: state.localeSelector,
    languages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLocaleChange: (language) => {
      dispatch(changeLocale(language));
    },
  };
};

const LocaleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Locale);

export default LocaleContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/LocaleContainer.js
 **/